import { render, staticRenderFns } from "./TagDetailsDialog.vue?vue&type=template&id=196f0358&scoped=true"
import script from "./TagDetailsDialog.vue?vue&type=script&lang=js"
export * from "./TagDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f0358",
  null
  
)

export default component.exports